//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NsProductCardBase from "./NsProductCardBase.vue";
import NsProductMixin from "../mixins/NsProductMixin.js";

/**
 * NsProductCard
 *
 * How to use: Any variables used in the template that are not props in this
 * component come from the mixin.
 *
 * @event variant-select  When a variant selection occurs, this event emits a
 * function with params: (value, index)
 * @event product-update  When a product updates, this event emits a function
 * with params: (product)
 * @event card-click  When clicking on the ProductCard, this event emits a
 * function with params: (product). If listener is NOT assigned, clicking the
 * card will go to the product detail page
 */

export default {
  name: "NsProductCard",
  components: {
    NsProductCardBase
  },
  mixins: [NsProductMixin],
  props: {
    /**
     * Always show the sv value
     */
    forcesv: Boolean,
    /**
     * Hides the Exclusive Icon
     */
    hideExclusiveIcon: Boolean,
    /**
     * Hides Exclusive Text only on mobile
     */
    hideExclusiveTextOnMobile: Boolean,
    /**
     * Hides the Favorites Icon
     */
    hideFavorites: Boolean,
    /**
     * Hides the Sku number
     */
    hideSku: Boolean,
    /**
     * Determines if the product card should have the small-width styling to support side-by-side in mobile
     */
    mobileSideBySide: Boolean,
    /**
     * Won't show the Action area on hover
     */
    noAction: Boolean,
    /**
     * Force the Action area to always show
     */
    showAction: Boolean
  },
  data() {
    return {
      referrer: "productCard"
    };
  }
};
